'use strict';

import $ from 'jquery';

export default class HomeMap {
  constructor() {
    let $map = $('.home-map');
    let $mapPins = $map.find('.map-pin');
    let $mapItem = $('.map-pin__item', $map);
    let $mapList = $('.map-nav-item__link', $map);
    let $mapID = $mapPins.attr('id');
    let $mapCard = $('.home-map-card', $map);
    let $mapOverlay = $('.map-image', $map);

    this.$mapList = $mapList;
    this.$mapPins = $mapPins;
    this.$mapCard = $mapCard;

    // let $clickableMapPins = $mapItem.not('.disable');
    // let $mapNavList = $('.map-nav-item').not('.disable');
    let $clickableMapPins = $mapItem;
    let $mapNavList = $('.map-nav-item');
    let hoverTimeout;

    $clickableMapPins.click(function() {

      let $this = $(this),
      mapPin = $this.find('.map-pin'),
      $id = mapPin.attr('id');

      $mapPins.removeClass('is-open');
      mapPin.addClass('is-open');

      $mapItem.css('z-index', '1');
      $this.css('z-index', '2');

      $mapCard.removeClass('is-open');
      mapPin.siblings('.home-map-card').addClass('is-open');

      $mapList.removeClass('active');
      $(`.map-nav-item__link[data-attributes=${$id}]`).addClass('active');

    })

    //map navigation
    $mapNavList.click(function(e) {
      e.preventDefault();
      let $this = $(this),
          currentLink = $this.find('.map-nav-item__link'),
          $link = currentLink.data('attributes');
          
      let $currentPin = $(`.map-pin[id=${$link}]`);
      
      $mapList.removeClass('active');
      currentLink.addClass('active');

      //map card
      $mapItem.css('z-index', '1');
      $currentPin.parents('.map-pin__item').css('z-index', '2');
      $mapCard.removeClass('is-open');
      $currentPin.siblings('.home-map-card').addClass('is-open');

      //map pin
      $mapPins.removeClass('is-open');
      $currentPin.addClass('is-open');
    });

    //map navigation on focus
    $mapNavList.on('focusin', function(){

      let $this = $(this),
          currentLink = $this.find('.map-nav-item__link'),
          $link = currentLink.data('attributes');
          
      let $currentPin = $(`.map-pin[id=${$link}]`);
  
      $mapList.removeClass('active');
      currentLink.addClass('active');

      //map card
      $mapItem.css('z-index', '1');
      $currentPin.parents('.map-pin__item').css('z-index', '2');
      $mapCard.removeClass('is-open');
      $currentPin.siblings('.home-map-card').addClass('is-open');

      //map pin
      $mapPins.removeClass('is-open');
      $currentPin.addClass('is-open');
    }).on('focusout', function(){

      //remove map navigation
      $mapList.removeClass('active');

      //remove map card
      $mapItem.css('z-index', '1');
      $mapCard.removeClass('is-open');

      //remove map pin
      $mapPins.removeClass('is-open');
    });


    //map navigation onHover
    $mapNavList.map((i, ele) => {
      let $this = $(ele),
          currentLink = $this.find('.map-nav-item__link'),
          $link = currentLink.data('attributes');

      $this.on('mouseenter', () => {
        hoverTimeout = setTimeout(() => {

          let $currentPin = $(`.map-pin[id=${$link}]`);
          
          $mapPins.removeClass('is-hover');
          $currentPin.addClass('is-hover');

        }, 200);
      });

    });

    $mapNavList.on('mouseleave', e => {
      $mapPins.removeClass('is-hover');
      clearTimeout(hoverTimeout);
      
    });

    //map pin onHover
    $mapItem.map((i, ele) => {
      let $this = $(ele),
          currentPin = $this.find('.map-pin'),
          $pin = currentPin.attr('id');
      
      $this.on('mouseenter', () => {
        hoverTimeout = setTimeout(() => {

          let $currentLink = $(`.map-nav-item__link[data-attributes=${$pin}]`);

          $mapList.removeClass('is-hover');
          $currentLink.addClass('is-hover');

        }, 200);
      });
    });

    $mapItem.on('mouseleave', e => {
      clearTimeout(hoverTimeout);
      $mapList.removeClass('is-hover');
    });


    // $('.map-nav-item.disable').click(function(e) {
    //   e.preventDefault();
    // })

    $mapOverlay.on('click', e => {
      e.preventDefault();

      this.closeHomeMap();

    });

  }

  closeHomeMap() {
    this.$mapPins.removeClass('is-open');
    this.$mapCard.removeClass('is-open');
    this.$mapList.removeClass('active');
  }
}
